import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useParams, Link as RouterLink} from "react-router-dom";
import {Breadcrumbs, Container, Grid, Link, Typography} from "@mui/material";
import GuestInfoStepper from "../../../components/GuestInfo/GuestInfoStepper";
import {setStep} from "../../../redux/actions/stepActions";
import InformationForm from "../../../components/GuestInfo/GuestForm/InformationForm";
import GuestBar from "../../../components/GuestInfo/GuestBar";
import {getBookingFormData} from "../../../redux/actions/bookingFormActions";
import {useIsAuthenticated} from "react-auth-kit";
import ValidateAccess from "../../../components/ValidateAccess/ValidateAccess";
import {format, parse} from "date-fns";
import PreTripCard from "../../../components/GuestInfo/MyBooking/PreTripCard";

const PersonalInformationPage = () => {
    ValidateAccess();
    const dispatch = useDispatch();
    const {id} = useParams();
    const {booking, form} = useSelector(state => state.bookingForm);
    const isAuth = useIsAuthenticated();

    useEffect(() => {
        dispatch(setStep(1));
    }, []);

    useEffect(() => {
        if (!booking || form.guestFk !== parseInt(id))
            getGuestAndTrip().catch();
    }, [booking?.id]);


    const getGuestAndTrip = async () => {
        const accessToken = sessionStorage.getItem('accessToken');
        dispatch(getBookingFormData(id, accessToken));
    };

    return (
        <>
            {isAuth() && booking && <GuestBar>
                <Breadcrumbs aria-label="breadcrumb" separator={'>'}>
                    <Link component={RouterLink} underline="hover" color="inherit" to="/booking/my-bookings">
                        Bookings
                    </Link>
                    <Link component={RouterLink} underline="hover" color="inherit" to={`/booking/my-bookings/${booking.id}`}>
                        {format(parse(booking.tripDate, 'yyyy-MM-dd', new Date()), 'LLLL d, yyyy')}
                    </Link>
                    <Typography color="text.primary">{form?.guestInfo?.firstName ? `${form.guestInfo.firstName} ${form.guestInfo.lastName}` : 'Guest Form'}</Typography>
                </Breadcrumbs>
            </GuestBar>}
            <Container sx={{marginTop: '20px'}}>
            </Container>
            {booking && <Container>
                <GuestInfoStepper />
                 <div style={{marginTop: 50}}>
                    <Grid container spacing={3} sx={{px: {xs: '1.6rem', lg: '0'}}}>
                        <Grid item xs={12} sm={12}>
                            {booking.trip && <PreTripCard booking={booking}/>}
                        </Grid>
                        <Grid item xs={12} style={{marginTop: 50}}>
                            <InformationForm/>
                        </Grid>
                    </Grid>
                </div>
            </Container>}
        </>
    );
};

export default PersonalInformationPage;